module.exports = __webpack_public_path__ + "static/media/ic_process_done.7873246f.svg";